module.exports = __webpack_public_path__ + "static/media/my-profile.87dc85f5.svg";